import Layout from '../../..//layout'
const asyncStandardMarkersManagementRoutes =
{
  path: '/stock/standardMarkersManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '标准物管理',
  funcPerms: 'stock:stamat',
  alwaysShow: true,
  meta: {
    title: '标准物管理',
    icon: 'markers',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'markers/inventoryQuery',
      component: () => import('../../../views/oa/standardMarkersManagement/inventoryQuery/index.vue'),
      funcPerms: 'oa:stamat:stock:query',
      name: 'markers/inventoryQuery',
      meta: {
        title: '库存查询',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'markers/purchasePlan',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchasePlan/index'),
    //   funcPerms: 'oa:stamat:purchasePlan',
    //   name: 'markersPurchasePlan',
    //   meta: {
    //     title: '标准物采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchasePlan/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchasePlan/view'),
    //   funcPerms: 'oa:stamat:purchasePlan:view',
    //   name: 'markersPurchasePlanView',
    //   hidden: true,
    //   meta: {
    //     title: '查看标准物采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchasePlan/viewSummary',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchasePlan/viewSummary'),
    //   funcPerms: 'oa:stamat:purchasePlan:viewSummary',
    //   name: 'markersPurchaseviewsSummary',
    //   hidden: true,
    //   meta: {
    //     title: '查看汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchasePlan/detail',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchasePlan/detail'),
    //   funcPerms: 'oa:stamat:purchasePlan:detail',
    //   name: 'markersPurchasePlanDetail',
    //   hidden: true,
    //   meta: {
    //     title: '查看明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchasePlan/submitReview',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchasePlan/submitReview'),
    //   funcPerms: 'oa:stamat:purchasePlan',
    //   name: 'markersPurchasePlan-submitReview',
    //   hidden: true,
    //   meta: {
    //     title: '提交审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchase',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchase/index'),
    //   funcPerms: 'oa:stamat:purchaseApply',
    //   name: 'markersPurchase',
    //   meta: {
    //     title: '标准物采购',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchase/add',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchase/add'),
    //   funcPerms: 'oa:stamat:purchaseApply',
    //   name: 'MarkersPurchaseApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'markers/purchase/edit',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchase/add'),
    //   funcPerms: 'oa:stamat:purchaseApply',
    //   name: 'MarkersPurchaseApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'markers/purchase/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchase/view'),
    //   funcPerms: 'oa:stamat:purchase',
    //   name: 'markersPurchaseApplication-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'markers/purchaseReview',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchaseReview/index'),
    //   funcPerms: 'oa:stamat:purchaseReview',
    //   name: 'markersPurchaseReview',
    //   meta: {
    //     title: '标准物采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'markers/purchaseReview/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/purchaseReview/view'),
    //   funcPerms: 'oa:stamat:purchaseReview',
    //   name: 'markersPurchaseReview-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看标准物采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersApplication',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentApplication/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersApplication',
    //   meta: {
    //     title: '标准物申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersApplication/add',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增标准物申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersApplication/edit',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑标准物申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersApplication/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersApplicationView',
    //   hidden: true,
    //   meta: {
    //     title: '查看标准物申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersWarehouserVerify',
    //   component: () => import('../../../views/oa/standardMarkersManagement/warehouserVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersWarehouserVerify',
    //   meta: {
    //     title: '库管审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersWarehouserVerify/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/warehouserVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersWarehouserVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '库管审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDepttHeaderVerify',
    //   component: () => import('../../../views/oa/standardMarkersManagement/depttHeaderVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDepttHeaderVerify',
    //   meta: {
    //     title: '科主任审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDepttHeaderVerify/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/depttHeaderVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDepttHeaderVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDepttHeaderSummary',
    //   component: () => import('../../../views/oa/standardMarkersManagement/depttHeaderSummary/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDepttHeaderSummary',
    //   meta: {
    //     title: '科主任汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDepttHeaderSummary/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/depttHeaderSummary/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDepttHeaderSummaryView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任汇总详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersFinanceVerify',
    //   component: () => import('../../../views/oa/standardMarkersManagement/financeVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersFinanceVerify',
    //   meta: {
    //     title: '财务审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersFinanceVerify/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/financeVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersFinanceVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '财务审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersAffairsDeptVerify',
    //   component: () => import('../../../views/oa/standardMarkersManagement/affairsDeptVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersAffairsDeptVerify',
    //   meta: {
    //     title: '总务科审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersAffairsDeptVerify/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/affairsDeptVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersAffairsDeptVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '总务科审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersStorage',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersStorage',
    //   meta: {
    //     title: '标准物入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersStorage/add',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentStorage/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersStorageAdd',
    //   hidden: true,
    //   meta: {
    //     title: '入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersOutbound',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentOutbound/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersOutbound',
    //   meta: {
    //     title: '标准物出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersOutbound/out',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentOutbound/out'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersOutboundOut',
    //   hidden: true,
    //   meta: {
    //     title: '出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersOutbound/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/reagentOutbound/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersOutboundView',
    //   hidden: true,
    //   meta: {
    //     title: '出库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDeptManagerStorage',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptManagerStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptManagerStorage',
    //   meta: {
    //     title: '科室库管入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDeptManagerStorage/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptManagerStorage/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptManagerStorageView',
    //   hidden: true,
    //   meta: {
    //     title: '科室库管入库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDeptUseApply',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptUseApply/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptUseApply',
    //   meta: {
    //     title: '科室使用申领',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'markers/inventoryDetails',
      component: () => import('../../../views/oa/standardMarkersManagement/inventoryDetails/index.vue'),
      funcPerms: 'stock:stamat:stockin:detail',
      name: 'markers/inventoryDetails',
      meta: {
        title: '入库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'markers/OutboundDetail',
      component: () => import('../../../views/oa/standardMarkersManagement/OutboundDetail/index.vue'),
      funcPerms: 'stock:stamat:stockout:detail',
      name: 'markers/OutboundDetail',
      meta: {
        title: '出库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'markers/deptUseApply',
      component: () => import('../../../views/oa/standardMarkersManagement/deptUseApply/index.vue'),
      funcPerms: 'stock:stamat:useApply',
      name: 'markers/deptUseApply',
      meta: {
        title: '使用申领',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'markers/deptUseApply/query',
      component: () => import('../../../views/oa/standardMarkersManagement/deptUseApply/query'),
      funcPerms: 'stock:hr:manager',
      name: 'markers/deptUseApplyQuery',
      hidden: true,
      meta: {
        title: '查询库存',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/markersDeptUseApply/edit',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptUseApplyEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑申领',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersDeptUseApply/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptUseApplyView',
    //   hidden: true,
    //   meta: {
    //     title: '申领详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'markers/deptUseApplyVerify',
      component: () => import('../../../views/oa/standardMarkersManagement/deptUseApplyVerify/index'),
      funcPerms: 'stock:stamat:applyAudit',
      name: 'markers/deptUseApplyVerify',
      meta: {
        title: '申领审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/markersDeptUseApplyVerify/view',
    //   component: () => import('../../../views/oa/standardMarkersManagement/deptUseApplyVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersDeptUseApplyVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '使用申领审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'markers/inventoryImport',
      component: () => import('../../../views/oa/standardMarkersManagement/inventoryImport/index.vue'),
      funcPerms: 'stock:hr:manager',
      name: 'markers/inventoryImport',
      meta: {
        title: '库存导入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
    // {
    //   path: '/markersStoragePlace',
    //   component: () => import('../../../views/oa/standardMarkersManagement/storagePlace/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersStoragePlace',
    //   meta: {
    //     title: '存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersStoragePlace/add',
    //   component: () => import('../../../views/oa/standardMarkersManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersStoragePlaceAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/markersStoragePlace/edit',
    //   component: () => import('../../../views/oa/standardMarkersManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'markersStoragePlaceEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // }
  ]
}

export default asyncStandardMarkersManagementRoutes
